import { render, staticRenderFns } from "./PerimeterCompany.vue?vue&type=template&id=4b7321db&scoped=true"
import script from "./PerimeterCompany.vue?vue&type=script&lang=js"
export * from "./PerimeterCompany.vue?vue&type=script&lang=js"
import style0 from "./PerimeterCompany.vue?vue&type=style&index=0&id=4b7321db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7321db",
  null
  
)

export default component.exports